import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import * as RosterLiteMember from '@modules/roster-lite/models/rosterLiteMember';
import {
  useGetOrgAdultsQuery,
  useGetOrgYouthsQuery,
} from '@modules/roster/api';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

export function useRosterLite({ skip = false }: { skip?: boolean }) {
  // Use organizationGuidSel (not selectedOrganizationSel) so parent/guardian
  // composite guids ("orgGuid*mid") are stripped to the plain org guid; the
  // composite form makes the orgYouths/orgAdults endpoints 403.
  const organizationGuid = useSelector(organizationGuidSel);

  const { data: youthData = { members: [] }, isFetching: loadingYouths } =
    useGetOrgYouthsQuery(
      {
        organizationGuid,
        body: { includeExpired: false },
      },
      { skip: !organizationGuid || skip },
    );

  const { data: adultData = { members: [] }, isFetching: loadingAdults } =
    useGetOrgAdultsQuery(
      {
        organizationGuid,
        body: { includeExpired: false },
      },
      { skip: !organizationGuid || skip },
    );

  const members = useMemo<RosterLiteMember.RosterLiteMember[]>(
    () => RosterLiteMember.uniqueMembers(youthData.members, adultData.members),
    [youthData.members, adultData.members],
  );

  return { members, loadingYouths, loadingAdults };
}
